import React, { useMemo, useState } from "react";
import { Container } from "@material-ui/core";
import { BasicTabs } from "../CustomTabPanel";
import { Header } from "../shared/Style/Style";
import { TabList } from "../School/UpdateSchool";
import { UsersTab } from "./UsersTab";
import { ReportsTab } from "./ReportsTab";

const TAB_HEADERS = [
  "Список пользователей связанных с LMS",
  "Звіт: підключення шкіл до LMS",
];

export const LmsUsersList: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabList = useMemo<TabList[]>(
    () => [
      { tabName: "КОРИСТУВАЧІ", TabPanel: <UsersTab /> },
      { tabName: "ЗВІТИ", TabPanel: <ReportsTab /> },
    ],
    []
  );

  return (
    <Container maxWidth="lg">
      <Header>{TAB_HEADERS[activeTab]}</Header>
      <BasicTabs
        tabList={tabList}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />
    </Container>
  );
};
